import { render, staticRenderFns } from "./RiskWordList.vue?vue&type=template&id=5e710150&scoped=true"
import script from "./RiskWordList.vue?vue&type=script&lang=js"
export * from "./RiskWordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e710150",
  null
  
)

export default component.exports